var React = require('react');

function PersonOutline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8,1c1.7,0,3,1.3,3,3S9.7,7,8,7S5,5.7,5,4S6.4,1,8,1 M8,0C5.8,0,4,1.8,4,4s1.8,4,4,4s4-1.8,4-4S10.2,0,8,0L8,0z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M8,10.4l5.6,2.9V15H2.3v-1.8L8,10.4 M8.1,9.3l-6.7,3.3V16h13.3v-3.3L8.1,9.3L8.1,9.3z","fill":"currentColor","key":1})]);
}

PersonOutline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = PersonOutline;

PersonOutline.default = PersonOutline;
